// extracted by mini-css-extract-plugin
module.exports = {"filterContainer":"ClosedClientList_filterContainer__20POl","paginationWrapper":"ClosedClientList_paginationWrapper__3C0uE","loading":"ClosedClientList_loading__qLTOK"};